import cn from "classnames"
import { useRef } from "react"

import { Flex, Select } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"
import { TitleStepDeployTab } from "@/pages/DeploymentsPage/components/molecules/DeployTab"

import styles from "./OSStep.module.scss"

import type { SelectStepOption, SelectStepProps } from "."

export const SelectStepTitle = (props: SelectStepProps<string>) => {
  const { t } = useTranslation("translation", {
    keyPrefix: "integrations.connect.kodemCLI.platform"
  })
  const options = useRef<SelectStepOption<string>[]>([])

  if (options.current.length === 0) {
    const platforms = ["linux_arm64", "linux_amd64", "windows_amd64"] as const

    options.current =
      props.options ||
      platforms.map((platform) => ({ label: t(platform), value: platform }))
  }

  const { classes } = props

  return (
    <Flex align="center" className={styles.wrapper} gap={8}>
      <TitleStepDeployTab prefix={props.t("deployments.selectOS.prefix")} />
      <Select
        size={props.size}
        rootClassName={cn(styles.selectRoot, classes?.select)}
        placeholder={props.placeholder ?? props.t("deployments.selectOS.1")}
        options={options.current}
        defaultValue={props.defaultValue}
        // At least as wide as the select, wider when an option needs it (the
        // selected option is bolder than the placeholder-sized select)
        popupMatchSelectWidth={false}
        onSelect={props.setOSPlatform}
      />
    </Flex>
  )
}
